import React from "react";
import Tasks from "./tasks";
import Footer from '../layouts/Footer';

const Dashboard = props => 
    <div>
        <Tasks />
    </div>
export default Dashboard;